import { db } from '../firebase/FireDataContext';

const neutralise = obj => JSON.parse(JSON.stringify(obj, (_, value) => value ?? ''));

const Errata = {
    log: ({ component, user, error: { message = '', stack = {} } }) => {
        const { uid, name } = user;

        try {
            const payload = neutralise({
                component,
                message,
                stack,
                uid,
                name,                
                ts: new Date().valueOf(),
            });

            db.insert({
                path: `errors`,
                payload,
                context: 'Errata'
            })
                .then(({ id = 'WTAF!' }) => console.log(`Errata logged ${id}`))
                .catch(err => console.log('Errata failed to log ', err, component, message, stack));

        }
        catch (err) {
            console.log('Errata error!', err, component, message, stack);
        }
    }
}

export default Errata;